import { ChangeEvent, DataSourceExecutionEvent, DataSourceValidationEvent, Snackbar, Textbox, ValidationResult } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutTrailerDetentionReport } from "./autogen/AutogenLayoutTrailerDetentionReport";

export class TrailerDetentionReport extends AutogenLayoutTrailerDetentionReport {

    onLoad(): void {
        this.textboxGroupBy.setSelectedItemFromDisplayValue("Trailer");
    }

    textboxGroupByOnChange() {
        if(this.textboxGroupBy.text == "Customer") {
            this.checkboxPageBreak.enabled = true;
        }
        else {
            this.checkboxPageBreak.checked = false;
            this.checkboxPageBreak.enabled = false;
        }
    }

    private resetValidationWarnings() {
        this.textboxDaysA.validationWarning = null;
        this.textboxDaysB.validationWarning = null;
        this.textboxDaysC.validationWarning = null;
        this.textboxDaysD.validationWarning = null;
        this.textboxDaysE.validationWarning = null;
        this.textboxThroughA.validationWarning = null;
        this.textboxThroughB.validationWarning = null;
        this.textboxThroughC.validationWarning = null;
        this.textboxThroughD.validationWarning = null;
        this.textboxThroughE.validationWarning = null;
        this.textboxDailyRateA.validationWarning = null;
        this.textboxDailyRateB.validationWarning = null;
        this.textboxDailyRateC.validationWarning = null;
        this.textboxDailyRateD.validationWarning = null;
        this.textboxDailyRateE.validationWarning = null;
        this.textboxDaysDropped.validationWarning = null;
        this.textboxFreeDaysAllowed.validationWarning = null;
    }

    trailerDetentionOnValidate(event: DataSourceValidationEvent){
        // Clear any existing validation warnings
        this.resetValidationWarnings();

        // Validate begin values for each row
        this.handleValidationError(event, this.textboxDaysA, this.validateBeginValue(this.textboxDailyRateA, this.textboxDaysA, null, null));
        this.handleValidationError(event, this.textboxDaysB, this.validateBeginValue(this.textboxDailyRateB, this.textboxDaysB, this.textboxDaysA, this.textboxThroughA));
        this.handleValidationError(event, this.textboxDaysC, this.validateBeginValue(this.textboxDailyRateC, this.textboxDaysC, this.textboxDaysB, this.textboxThroughB));
        this.handleValidationError(event, this.textboxDaysD, this.validateBeginValue(this.textboxDailyRateD, this.textboxDaysD, this.textboxDaysC, this.textboxThroughC));
        this.handleValidationError(event, this.textboxDaysE, this.validateBeginValue(this.textboxDailyRateE, this.textboxDaysE, this.textboxDaysD, this.textboxThroughD));

        // Validate thru values for each row
        this.handleValidationError(event, this.textboxThroughA, this.validateThruValue(this.textboxDailyRateA, this.textboxDaysA, this.textboxThroughA, null, null));
        this.handleValidationError(event, this.textboxThroughB, this.validateThruValue(this.textboxDailyRateB, this.textboxDaysB, this.textboxThroughB, this.textboxDaysA, this.textboxThroughA));
        this.handleValidationError(event, this.textboxThroughC, this.validateThruValue(this.textboxDailyRateC, this.textboxDaysC, this.textboxThroughC, this.textboxDaysB, this.textboxThroughB));
        this.handleValidationError(event, this.textboxThroughD, this.validateThruValue(this.textboxDailyRateD, this.textboxDaysD, this.textboxThroughD, this.textboxDaysC, this.textboxThroughC));
        this.handleValidationError(event, this.textboxThroughE, this.validateThruValue(this.textboxDailyRateE, this.textboxDaysE, this.textboxThroughE, this.textboxDaysD, this.textboxThroughD));

        // Validate integer values
        this.handleValidationError(event, this.textboxDaysDropped, this.validateIntegerValue(this.textboxDaysDropped));
        this.handleValidationError(event, this.textboxFreeDaysAllowed, this.validateIntegerValue(this.textboxFreeDaysAllowed));
        this.handleValidationError(event, this.textboxDailyRateA, this.validateIntegerValue(this.textboxDailyRateA));
        this.handleValidationError(event, this.textboxDailyRateB, this.validateIntegerValue(this.textboxDailyRateB));
        this.handleValidationError(event, this.textboxDailyRateC, this.validateIntegerValue(this.textboxDailyRateC));
        this.handleValidationError(event, this.textboxDailyRateD, this.validateIntegerValue(this.textboxDailyRateD));
        this.handleValidationError(event, this.textboxDailyRateE, this.validateIntegerValue(this.textboxDailyRateE));
    }

    private handleValidationError(event: DataSourceValidationEvent, textbox: Textbox, errorMsg: string): void {
        if (errorMsg) {
            textbox.validationWarning = errorMsg;
            event.validationResults.push({ isValid: false, validationMessage: errorMsg, caption: errorMsg, component: textbox });
        }
    }

    // Ported from ParamTrailerDetentionReport.java
    private validateBeginValue(
        rateDay: Textbox,
        beginDay: Textbox,
        beginDayPrior: Textbox | null,
        endDayPrior: Textbox | null
    ): string | null {
        let retMsg: string | null = null;

        // Invalid if daily rate is populated but begin day is not
        if (!StringUtil.isEmptyString(rateDay.text) && StringUtil.isEmptyString(beginDay.text)) {
            retMsg = "Days value must be populated if a daily rate is given.";
            return retMsg;
        }

        if (beginDayPrior !== null && endDayPrior !== null) {
            let beginPriorDayNum = 0;
            let endPriorDayNum = 0;
            let beginDayNum = 0;

            if (!StringUtil.isEmptyString(beginDay.text)) {
                beginDayNum = parseInt(beginDay.text);
            }

            if (!StringUtil.isEmptyString(beginDayPrior.text)) {
                beginPriorDayNum = parseInt(beginDayPrior.text);
            }

            if (!StringUtil.isEmptyString(endDayPrior.text)) {
                endPriorDayNum = parseInt(endDayPrior.text);
            }

            if (beginDayNum !== 0 && endPriorDayNum !== 0) {
                if (beginDayNum !== endPriorDayNum + 1) {
                    retMsg = "Day value must be contiguous with the prior thru date value";
                }

                if (beginDayNum >= beginPriorDayNum && beginDayNum <= endPriorDayNum) {
                    retMsg = "Value given falls within the previous day range.";
                }
            }
        }

        return retMsg;
    }

    // Ported from ParamTrailerDetentionReport.java
    private validateThruValue(
        rateDay: Textbox,
        beginDay: Textbox,
        thruDay: Textbox,
        beginDayPrior: Textbox | null,
        endDayPrior: Textbox | null
    ): string | null {
        let retMsg: string | null = null;

        if (!StringUtil.isEmptyString(rateDay.text) && StringUtil.isEmptyString(thruDay.text)) {
            retMsg = "Thru value must be populated if a daily rate is given.";
            return retMsg;
        }

        if (beginDayPrior !== null && endDayPrior !== null) {
            let beginPriorDayNum = 0;
            let endPriorDayNum = 0;
            let endDayNum = 0;
            let beginDayNum = 0;

            if (!StringUtil.isEmptyString(beginDay.text)) {
                beginDayNum = parseInt(beginDay.text);
            }

            if (!StringUtil.isEmptyString(thruDay.text)) {
                endDayNum = parseInt(thruDay.text);
            }

            if (!StringUtil.isEmptyString(beginDayPrior.text)) {
                beginPriorDayNum = parseInt(beginDayPrior.text);
            }

            if (!StringUtil.isEmptyString(endDayPrior.text)) {
                endPriorDayNum = parseInt(endDayPrior.text);
            }

            if (endDayNum !== 0 && endPriorDayNum !== 0) {
                if (endDayNum >= beginPriorDayNum && endDayNum <= endPriorDayNum) {
                    retMsg = "Value given falls within the previous day range.";
                }
            }

            if (endDayNum > 0 && endDayNum < beginDayNum) {
                retMsg = "Thru value can not be less than day value";
            }
        }

        return retMsg;
    }

    // Ported from ParamTrailerDetentionReport.java
    validateIntegerValue(textbox: Textbox): string | null {
        if (!StringUtil.isEmptyString(textbox.text) && parseInt(textbox.text) < 0) {
            return "Value cannot be less than zero.";
        }
    }
}
